export const sortCaseInsensitive = (a: string | null | undefined, b: string | null | undefined) => {
  if (!a && !b) {
    return 0;
  }
  if (!a) {
    return 1;
  }
  if (!b) {
    return -1;
  }
  if (a === b) {
    return 0;
  }
  return a.localeCompare(b, 'en', { sensitivity: 'accent' });
};
